module.exports = __webpack_public_path__ + "img/HPS014CP.cc9ed32b.png";